import type { FaireProductEntity } from "../../entity_types/product";

export const p_thd379vd7n: FaireProductEntity = {
  token: "p_thd379vd7n",
  type: "product",
  name: "LANEIGE Lip Glowy Balm 10g 0.35oz",
  brandToken: "b_78a5y9jxe7",
  brandName: "Glowiss",
  imageUrl:
    "https://cdn.faire.com/fastly/44d1e82a28179cc15fc8fd7e2d75523a87032778ae4cae1d5b56e7dd5825567c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b0ad44b8d35de9ae020d4a975cfe05466f9a3e3d62794ee819bd48bfa4498948.png",
    "https://cdn.faire.com/fastly/d447d3eddc2b6c16b8263e811073f927f58a8fa73f74725c7a97dce5ecbd6a58.png",
    "https://cdn.faire.com/fastly/a8362322443e382e1148c27be135d6c43596509bd481999a2979df6e585c5bad.png",
    "https://cdn.faire.com/fastly/ac05f146d82125d5438a5ddd5a1e36a7592c779f2e1d9a259814ed60df398995.png",
    "https://cdn.faire.com/fastly/7160559d019b9dd83de08a91f5e34854953ea8151c5acc28c9bc99f750639d70.webp",
    "https://cdn.faire.com/fastly/aafecb3ff45d997c7c25e53da217251fb2e68efe0b901b24bd2034bbf994d6f5.png",
    "https://cdn.faire.com/fastly/a0cac3c8200f5cdca328675fadae1b20b370fc27c85f1645e83f493ec670ba51.webp",
  ],
  priceDollars: 12.8,
  description:
    "\nSay goodbye to dry, chapped lips with LANEIGE Lip Glowy Balm! Its lightweight formula enriched with shea and murumuru seed butters keeps your lips soft and hydrated all day long. Say hello to kissable lips!\n",
  tags: [],
  msrpDollars: 25.6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:14.485Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
